import { type SortDirection, type Table } from "@tanstack/react-table"
import {
  Header,
  MenuItem,
  MenuSection,
  Separator,
} from "@tokenterminal/core/ui/menu/MenuButton"
import CaretUpDownDown from "@tokenterminal/core/ui/table/CaretUpDownDown"
import CaretUpDownUp from "@tokenterminal/core/ui/table/CaretUpDownUp"
import HeaderWithSubtitle from "@tokenterminal/core/ui/table/HeaderWithSubtitle"
import * as CoreTable from "@tokenterminal/core/ui/table/Table"
import { type PresetColumnConfig } from "@tokenterminal/tt-analytics-api-types/dist/api/projects"

import { useMemo } from "react"
import { HeaderActionButton } from "./HeaderActionButton"
import { leftAlignedColumns } from "./Table"

export const TableHeader = ({
  header,
  columns,
}: {
  table: Table<any>
  header: any
  columns: PresetColumnConfig[]
  compact: boolean
  isSticking: boolean
}) => {
  const sortingDirection = header.column.getIsSorted()

  const actions = useMemo(() => {
    const actions = [
      <MenuSection key="sort">
        <Header>Sort</Header>
        <MenuItem
          icon={CaretUpDownUp}
          onAction={() =>
            sortingDirection === "asc"
              ? undefined
              : header.column.toggleSorting(false)
          }
        >
          Ascending
        </MenuItem>
        <MenuItem
          icon={CaretUpDownDown}
          onAction={() =>
            sortingDirection === "desc"
              ? undefined
              : header.column.toggleSorting(true)
          }
        >
          Descending
        </MenuItem>
      </MenuSection>,
    ]

    const column = columns.find((c) => c.field === header.column.id)

    if (column?.metric_slug && column.metric_slug !== "price") {
      actions.push(<Separator key="separator" />)
      actions.push(
        <MenuItem
          key="view-metric"
          href={`/explorer/metrics/${column.metric_slug}`}
        >
          View metric
        </MenuItem>
      )
    }

    return actions
  }, [header.column, columns, sortingDirection])

  const isFirstColumn = header.column.id === "name"

  return (
    <CoreTable.HeaderCell
      className={
        isFirstColumn
          ? "sticky left-0 z-10 bg-bg-surface pinned-column-shadow"
          : ""
      }
      style={{
        width: header.column.getSize(),
        maxWidth: header.column.getSize(),
        minWidth: header.column.getSize(),
      }}
    >
      <div
        className={`flex gap-2 items-center ${leftAlignedColumns.includes(header.id) ? "justify-start" : "justify-end"}`}
      >
        {header.id === "price_30d_change_sparkline" ? (
          <HeaderWithSubtitle
            title="Price"
            subtitle="Change 30d"
            alignment="right"
          />
        ) : (
          <HeaderActionButton
            sortDirection={header.column.getIsSorted() as SortDirection}
            header={header}
            actions={actions}
          />
        )}
      </div>
    </CoreTable.HeaderCell>
  )
}
